<template>
  <div id="idleHome1">
    <div class="idleHome_box clearfix">
      <div class="idleHome_left">
        <div class="idleHome_left_title">热门推荐</div>
        <div class="idleHome_left_list" v-for="item in advertising" :key="item.p_id">
          <div class="idleHome_left_title_img">
            <img width="100%" :src="serve + item.images" alt />
          </div>
          <router-link
            :to="'/product/' + item.p_id"
            tag="div"
            class="idleHome_left_title_tit"
          >{{item.title}}</router-link>
          <!-- <div class="idleHome_left_title_tit">{{item.title}}</div> -->
          <div class="idleHome_left_title_yen">&yen; {{item.selling_price}}</div>
        </div>
      </div>
      <div class="idleHome_right">
        <!-- <div class="idleHome_right_seach clearfix">
          <div class="idleHome_right_seach_ipt">
            <el-input size="medium" v-model="seach_unit" style="width:510px;" placeholder="请输入内容"></el-input>
            <el-button size="medium" type="primary" @click="change_unit(1)">搜单位</el-button>
            <el-button size="medium" type="primary" @click="change_unit(2)">搜院系</el-button>
          </div>
        </div>-->

        <div class="bg">
          <el-row>
            <el-col :span="2">
              <div class="ify_tit">分类:</div>
            </el-col>
            <el-col :span="22">
              <div>
                <el-button
                  type="text"
                  class="c"
                  :class="activeId==null?'active':''"
                  @click="select(null,null)"
                >全部</el-button>
                <el-button
                  v-for="(item,index) of options"
                  :key="index"
                  type="text"
                  size="medium"
                  class="c"
                  :class="activeId==(index)?'active':''"
                  @click="select(index,item)"
                >{{item}}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="product_list">
          <el-row :gutter="20">
            <el-col :span="6" style="margin-bottom: 20px;" v-for="item in data " :key="item.id">
              <div class="product_item">
                <div class="product_img">
                  <img width="180px" height="180px" :src="serve + item.images" alt />
                </div>
                <div class="product_title">
                  <div
                    class="product_title_div1"
                  >{{item.title.length>12? item.title.slice(0,12) + '...' : item.title}}</div>
                  <div class="product_title_div2">{{item.nickname}}</div>
                </div>
                <router-link
                  tag="div"
                  class="product_share"
                  :to="'/share_details?id=' + item.id"
                >去分享</router-link>
              </div>
            </el-col>
            <div style="text-align:center;font-size:20px" v-if="data.length === 0">暂无信息</div>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serch_type: "",
      classify: "",
      seach_unit: "",
      serve: this.$store.state.serve,
      total: null,
      page: null,
      data: [],
      activeId: null,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      options: ["试剂", "设备", "耗材", "其他"],
      advertising: []
    };
  },
  activated() {
    this.$store.commit("set_top_nav", "7");
  },
  created() {
    this.initData();
    this.geting();
  },
  methods: {
    geting(v) {
      this.axios.get(this.serve + "/search_ad").then(res => {
        this.advertising = res.data;
        // for (var key in res.data) {
        //   this.advertising.push(res.data[key])
        // }
        // var x = parseInt(v / 2)
        // if (x == 0) {
        //   this.advertising.splice(0, 9)
        // } else {
        //   this.advertising.splice(0, 10 - x)
        // }
      });
    },
    change_unit(v) {
      this.serch_type = v;
      this.initData();
    },

    select(index, item) {
      this.activeId = index;
      this.classify = item;
      this.initData();
    },
    initData() {
      if (this.serch_type == "") {
        var where = {
          category: this.classify,
          unit: this.seach_unit
        };
      } else if (this.serch_type == "1") {
        var where = {
          category: this.classify,
          unit: this.seach_unit
        };
      } else if (this.serch_type == "2") {
        var where = {
          category: this.classify,
          department: this.seach_unit
        };
      }
      this.axios
        .get(this.serve + "/useless_exchange", {
          params: where
        })
        .then(res => {
          if (res.data.status == "success") {
            this.data = res.data.data.results;
            this.total = res.data.data.total;
            this.page = _.toInteger(res.data.data.page);
          }
        });
    }
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#idleHome1 {
  width: 100%;
  border-top: 2px solid #e2211c;
  .idleHome_box {
    width: 1200px;
    // min-height: 1000px;
    margin: 0 auto;
    .idleHome_left {
      width: 230px;
      float: left;
      margin-top: 21px;
      .idleHome_left_title {
        width: 100%;
        height: 38px;
        background: #ffffff;
        font-size: 16px;
        font-family: " Microsoft YaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 38px;
        text-align: center;
      }
      .idleHome_left_list {
        width: 230px;
        height: 306px;
        margin-bottom: 10px;
        font-family: " Microsoft YaHei";
        background: rgba(255, 255, 255, 1);
        margin-top: 1px;
        .idleHome_left_title_img {
          width: 190px;
          height: 190px;
          margin: 0 auto;
          padding-top: 20px;
          box-sizing: border-box;
        }
        .idleHome_left_title_tit {
          width: 190px;
          margin: 0 auto;
          font-size: 14px;
          margin: 30px 20px 20px 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .idleHome_left_title_tit:hover {
          color: rgba(226, 33, 28, 1);
        }
        .idleHome_left_title_yen {
          color: rgba(226, 33, 28, 1);
          width: 190px;
          margin: 0 auto;
          font-size: 16px;
        }
      }
    }
    .idleHome_right {
      width: 940px;
      float: right;
      .idleHome_right_seach {
        width: 100%;
        margin-top: 20px;
        .idleHome_right_seach_ipt {
          float: left;
          input {
            border-radius: 0px;
          }
          button {
            border-radius: 0px;
          }
        }
      }
      .bg {
        height: 40px;
        background: rgba(255, 255, 255, 1);
        margin-top: 20px;
        font-family: "Microsoft YaHei";
        .ify_tit {
          font-size: 14px;
          color: rgba(102, 102, 102, 1);
          line-height: 40px;
          padding-left: 9px;
        }
        .c {
          padding: 0px 10px;
          margin: 12px 5px;
          color: #333333;
        }
        .c.active {
          color: #e2211c;
        }
        // .t1 {
        //   font-size: 25px;
        //   margin: 30px 0;
        // }
        // .t2 {
        //   margin: 20px 0;
        // }
        // .go {
        //   transition: 0.3s;
        // }
        // .go:hover {
        //   background-color: #ddd;
        // }
      }
      .product_list {
        margin-top: 20px;
        width: 100%;
        .product_item {
          width: 220px;
          height: 300px;
          background: #fff;
          padding-top: 20px;
          // float: left;
          .product_img {
            width: 180px;
            height: 180px;
            margin: 0 auto;
          }
          .product_title {
            width: 180px;
            margin: 0 auto;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            .product_title_div1 {
              margin: 10px 0;
              cursor: pointer;
            }
            .product_title_div1:hover {
              color: #e2211c;
            }
            .product_title_div2 {
              margin-bottom: 13px;
            }
          }

          .product_share {
            width: 180px;
            height: 30px;
            background: rgba(226, 33, 28, 0);
            border: 1px solid rgba(246, 78, 98, 1);
            font-size: 14px;
            color: rgba(226, 33, 28, 1);
            text-align: center;
            line-height: 30px;
            margin: 0 auto;
            cursor: pointer;
          }
          .product_share:hover {
            background: rgba(226, 33, 28, 1);
            color: #fff;
          }
        }
      }
    }
  }

  .t0 {
    text-align: center;
    font-size: 20px;
    padding: 20px 0;
  }
  .pager {
    background-color: transparent;
    text-align: center;
  }
  .btn {
    border-top: 1px solid #ddd;
    padding: 10px 0;
    text-align: center;
  }
  .cover {
    height: 268px;
    width: 268px;
    background-position: center;
    background-size: 100% auto;
  }
  .pic {
    height: 30px;
    width: 30px;
    background-position: center;
    background-size: 100% auto;
    border-radius: 50%;
    overflow: hidden;
  }
  .t3 {
    padding: 10px 20px;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    margin-bottom: 20px;
  }
}
</style>